"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CustomIconOrImage = _interopRequireDefault(require("./shared/CustomIconOrImage"));
var _r10SourceLibrary = require("r10-source-library");
var _useLocalTheme = _interopRequireDefault(require("../hooks/useLocalTheme"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useQuestionnaireNavigation = require("../hooks/questionnaire/useQuestionnaireNavigation");
var _QuestionFooterNextButton = _interopRequireDefault(require("./Questionnaire/QuestionFooterNextButton"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useAppSelector = require("../hooks/useAppSelector");
var _questionnaireSelectors = require("../store/questionnaire/questionnaireSelectors");
var _logger = require("../services/logger");
var _services = require("../services");
var _constants = require("../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Wrapper = _styledComponents.default.div`
  margin-bottom: -20px;
  margin-top: -60px;
`;
const StyledGrid = (0, _styledComponents.default)(_r10SourceLibrary.Grid)`
  & #message-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    ${_r10SourceLibrary.Mixins.respondTo.md(`font-size: 36px;`)}
    ${_r10SourceLibrary.Mixins.respondTo.md(` font-weight: 400;`)}
    ${_r10SourceLibrary.Mixins.respondTo.md(`line-height: 40px;`)}
    color: #0d0d0d;
  }
  & #message-text {
    font-weight: 400;
    font-size: 16px;
    ${_r10SourceLibrary.Mixins.respondTo.md(`font-size: 18px;`)}
    line-height: 24px;
    color: #000000;
  }
`;
const StyledButton = _styledComponents.default.div`
  text-align: center;
  & > div {
    justify-content: center;
  }
  & button {
    margin-top: 30px;
    ${_r10SourceLibrary.Mixins.respondTo.md(`margin-top: 50px;`)}
    max-width: 300px;
    height: 48px;
  }
  @media (min-width: 1024px) {
    & > div {
      justify-content: flex-end;
    }
    & button {
      margin-left: 75px;
    }
  }
`;
const EntelIntroScreen = _ref => {
  var _metadata$handset, _metadata$handset$fil, _metadata$handset$fil2, _brandQuestion$choice, _brandQuestion$choice2;
  let {
    messageTitle,
    messageText,
    actionBtnText
  } = _ref;
  const {
    src,
    height,
    width
  } = (0, _useLocalTheme.default)('introScreenIcon') || {};
  const {
    onNext,
    isNextEnabled
  } = (0, _useQuestionnaireNavigation.useQuestionnaireNavigation)();
  const nextButtonAppearance = isNextEnabled ? 'primary' : 'secondary';
  const buttonTheme = (0, _useLocalTheme.default)('button');
  const metadata = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectMetadata);
  const questions = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectQuestions);
  const brandQuestion = questions.find(question => question.id === _constants.QUESTION_ID.BRANDS);
  const selectedBrand = metadata === null || metadata === void 0 ? void 0 : (_metadata$handset = metadata.handset) === null || _metadata$handset === void 0 ? void 0 : (_metadata$handset$fil = _metadata$handset.filters) === null || _metadata$handset$fil === void 0 ? void 0 : (_metadata$handset$fil2 = _metadata$handset$fil.brand) === null || _metadata$handset$fil2 === void 0 ? void 0 : _metadata$handset$fil2[0];
  const brandImage = brandQuestion === null || brandQuestion === void 0 ? void 0 : (_brandQuestion$choice = brandQuestion.choices) === null || _brandQuestion$choice === void 0 ? void 0 : (_brandQuestion$choice2 = _brandQuestion$choice.find(choice => {
    var _choice$characteristi, _choice$characteristi2, _choice$characteristi3, _choice$characteristi4;
    return ((_choice$characteristi = choice.characteristics) === null || _choice$characteristi === void 0 ? void 0 : (_choice$characteristi2 = _choice$characteristi[0]) === null || _choice$characteristi2 === void 0 ? void 0 : (_choice$characteristi3 = _choice$characteristi2.filter) === null || _choice$characteristi3 === void 0 ? void 0 : (_choice$characteristi4 = _choice$characteristi3[0]) === null || _choice$characteristi4 === void 0 ? void 0 : _choice$characteristi4.toLowerCase()) === (selectedBrand === null || selectedBrand === void 0 ? void 0 : selectedBrand.toLowerCase());
  })) === null || _brandQuestion$choice2 === void 0 ? void 0 : _brandQuestion$choice2.image;
  _logger.Logger.info({
    segments: [_logger.Logger.LOGGER_SEGMENTS.COMPONENTS]
  })('brandImage', brandImage);
  let brandTitle;
  const imageSource = brandImage || src;
  if (selectedBrand === 'Apple') {
    brandTitle = _services.Services.locale.localeString('IntroScreen.BrandTitles.Apple');
  } else if (selectedBrand) {
    brandTitle = _services.Services.locale.localeString('IntroScreen.BrandTitles.Other', {
      brand: selectedBrand
    });
  } else {
    brandTitle = messageTitle;
  }
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    id: "intro-screen-wrapper"
  }, /*#__PURE__*/_react.default.createElement(StyledGrid, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    iconWidth: width,
    iconHeight: height,
    src: {
      sm: imageSource,
      md: imageSource,
      lg: imageSource
    },
    testId: 'intro-image'
  })), brandTitle && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    justify: "center",
    level: 3,
    id: "message-title"
  }, brandTitle), messageText && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    justify: "center",
    id: "message-text"
  }, messageText)), /*#__PURE__*/_react.default.createElement(StyledButton, {
    id: "intro-screen-btn"
  }, /*#__PURE__*/_react.default.createElement(_QuestionFooterNextButton.default, {
    buttonTheme: buttonTheme,
    nextButtonAppearance: nextButtonAppearance,
    onNext: onNext,
    nextButtonColumns: 6,
    nextButtonText: actionBtnText
  })));
};
var _default = EntelIntroScreen;
exports.default = _default;
EntelIntroScreen.propTypes = {
  messageText: _propTypes.default.string,
  messageTitle: _propTypes.default.string,
  actionBtnText: _propTypes.default.string
};